import { useEffect, useState } from "react";
import { get } from "../../utility/fetch2";
import { RiEdit2Fill } from "react-icons/ri";
import notification from "../../utility/notification";
import axios from "axios";
import DetailedNurseNotes from "../modals/DetailedNurseNotes";
import WardRoundNotes from "../modals/WardRoundNotes";
import { useNavigate } from "react-router-dom";

function AdmitCheck({
  data,
  setCurrent,
  totalPages,
  currentPage,
  setCurrentPage,
}) {
  const [viewing, setViewing] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [wardRoundModalOpen, setWardRoundModalOpen] = useState(false);
  const [add, setAdd] = useState(false);
  const [combinedData, setCombinedData] = useState([]);
  const [patient, setPatient] = useState([]);
  const [loading, setLoading] = useState(false);
  const [beds, setBeds] = useState([]);
  const [bedList, setBedsList] = useState([]);
  const [patientName, setPatientName] = useState("");
  const [getAdmittedPatientsFunc, setGetAdmittedPatientsFunc] = useState(null);

  const navigate = useNavigate();

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrent(newPage);
      setCurrent(newPage);
    }
  };

  const generatePageNumbers = () => {
    let pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        pages = [1, 2, 3, 4, totalPages];
      } else if (currentPage >= totalPages - 2) {
        pages = [1, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
      } else {
        pages = [1, currentPage - 1, currentPage, currentPage + 1, totalPages];
      }
    }
    return pages;
  };

  const getAdmittedPatients = async (pageNumber = 1) => {
    try {
      const token = sessionStorage.getItem("token");
      if (!token) {
        console.error("Token not found in session storage");
        return;
      }

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      let res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/medicals/api/ServiceTreatment/list/paginate/true/admitted-patients?pageNumber=${pageNumber}&pageSize=10`,
        config,
      );

      if (res.data?.data?.recordList) {
        setPatient(res.data.data.recordList);
      }
    } catch (error) {
      console.error("Error fetching admitted patients:", error);
    }
  };

  const getAssignedBeds = async () => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("Token not found in session storage");
      return;
    }

    const options = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      let res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/clinicapi/api/bed/assign-bed/list/${1}/1000`,
        options,
      );
      setBeds(res?.data?.resultList || []);
    } catch (error) {
      console.error("Error fetching equipment:", error);
    }
  };

  const findPatientName = (id) => {
    if (!Array.isArray(patient)) {
      console.error("Error: 'patient' is not an array", patient);
      return "";
    }
    const patientRecord = patient?.find((p) => p?.patientId === id);

    return patientRecord
      ? `${patientRecord?.firstName} ${patientRecord?.lastName}`
      : "";
  };

  const isPatientOccupyingBed = (patientId) => {
    const bed = beds?.find((b) => b?.patient?.id === patientId);
    return bed ? bed?.bed?.name : "Assign patient a bed";
  };

  useEffect(() => {
    setGetAdmittedPatientsFunc(() => getAdmittedPatients);
    getAssignedBeds();
  }, []);

  useEffect(() => {
    setCombinedData(data);
  }, [data]);

  const closeModal = () => {
    setIsModalOpen(false);
    setAdd(false);
    setWardRoundModalOpen(false);
  };

  const selectRecord = (record) => () => {
    console.log("Selected record:", record.id);
    const patientName = record?.patient
      ? `${record.patient.firstName} ${record.patient.lastName}`
      : "";
    setPatientName(patientName);
    setIsModalOpen(true);
    setViewing(record);
  };

  const handleWardRound = (record) => {
    console.log("Opening Ward Round Notes for record:", record.id);
    const patientName = record?.patient
      ? `${record.patient.firstName} ${record.patient.lastName}`
      : "";
    setPatientName(patientName);
    setViewing(record);
    setWardRoundModalOpen(true);
  };

  const handleEdit = (recordId) => {
    setViewing(recordId);
    setAdd(true);
  };

  const getBedList = async () => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("Token not found in session storage");
      return;
    }

    const options = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      setLoading(true);
      let res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/clinicapi/api/bed/list/${1}/10`,
        options,
      );
      if (res.status === 200) {
        setBedsList(res?.data?.resultList || []);
      } else if (res.status === 500) {
        notification({ message: "Server Error", type: "error" });
        setBedsList([]);
      } else {
        setBedsList([]);
      }
    } catch (error) {
      setBedsList([]);
      console.error("Error fetching bed list:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-100">
      <div
        className="w-100 none-flex-item m-t-40"
        style={{
          overflowX: "auto",
          WebkitOverflowScrolling: "touch",
          maxWidth: "100%",
        }}
      >
        <table
          className="bordered-table"
          style={{ minWidth: "750px", width: "100%" }}
        >
          <thead className="border-top-none">
            <tr className="border-top-none">
              <th
                style={{
                  whiteSpace: "nowrap",
                  padding: "8px 12px",
                  fontSize: "clamp(0.75rem, 2.5vw, 0.9rem)",
                }}
              >
                #
              </th>
              <th
                style={{
                  whiteSpace: "nowrap",
                  padding: "8px 12px",
                  fontSize: "clamp(0.75rem, 2.5vw, 0.9rem)",
                }}
              >
                Date
              </th>
              <th
                style={{
                  whiteSpace: "nowrap",
                  padding: "8px 12px",
                  fontSize: "clamp(0.75rem, 2.5vw, 0.9rem)",
                }}
              >
                Time of Admission
              </th>
              {/* <th>Age</th> */}
              <th
                style={{
                  whiteSpace: "nowrap",
                  padding: "8px 12px",
                  fontSize: "clamp(0.75rem, 2.5vw, 0.9rem)",
                }}
              >
                Diagnosis
              </th>
              <th
                style={{
                  whiteSpace: "nowrap",
                  padding: "8px 12px",
                  fontSize: "clamp(0.75rem, 2.5vw, 0.9rem)",
                }}
              >
                Patient
              </th>
              <th
                style={{
                  whiteSpace: "nowrap",
                  padding: "8px 12px",
                  fontSize: "clamp(0.75rem, 2.5vw, 0.9rem)",
                }}
              >
                Bed Occupying
              </th>
              <th
                style={{
                  whiteSpace: "nowrap",
                  padding: "8px 12px",
                  fontSize: "clamp(0.75rem, 2.5vw, 0.9rem)",
                }}
              >
                Actions
              </th>
            </tr>
          </thead>

          <tbody className="white-bg view-det-pane">
            {data?.map((row, index) => {
              const formatDate = (dateString) => {
                if (!dateString) return "N/A";
                return new Date(dateString).toLocaleDateString("en-GB");
              };

              const formatTime = (dateString) => {
                if (!dateString) return "N/A";
                return new Date(dateString).toLocaleTimeString("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                });
              };

              const getPatientAge = () => {
                if (row.patient?.dateOfBirth) {
                  const dob = new Date(row.patient.dateOfBirth);
                  const today = new Date();
                  let age = today.getFullYear() - dob.getFullYear();
                  const monthDiff = today.getMonth() - dob.getMonth();
                  if (
                    monthDiff < 0 ||
                    (monthDiff === 0 && today.getDate() < dob.getDate())
                  ) {
                    age--;
                  }
                  return age;
                }
                return "N/A";
              };

              const getBedOccupying = (patientId) => {
                const bed = beds?.find((b) => b?.patient?.id === patientId);
                return bed ? bed?.bed?.name : "Not Assigned";
              };

              const patientName = row.patient
                ? `${row.patient.firstName} ${row.patient.lastName}`
                : "N/A";
              const patientId = row.patient?.id;

              return (
                <tr key={index}>
                  <td
                    style={{
                      padding: "8px 12px",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                    }}
                  >
                    {index + 1}
                  </td>
                  <td
                    style={{
                      padding: "8px 12px",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {formatDate(row.dateOfVisit)}
                  </td>
                  <td
                    style={{
                      padding: "8px 12px",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {formatTime(row.dateOfVisit)}
                  </td>
                  {/* <td>{getPatientAge()}</td> */}
                  <td
                    style={{
                      padding: "8px 12px",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                      maxWidth: "150px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {row.diagnosis || "N/A"}
                  </td>
                  <td
                    style={{
                      padding: "8px 12px",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {patientName}
                  </td>
                  <td
                    style={{
                      padding: "8px 12px",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {getBedOccupying(patientId)}
                  </td>
                  <td style={{ padding: "8px 12px" }}>
                    <div className="flex gap-8 flex-h-center">
                      <button
                        className="icon-btn"
                        onClick={() => handleWardRound(row)}
                        title="Ward Rounds"
                        style={{
                          padding: "5px 10px",
                          backgroundColor: "#28a745",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                          fontSize: "clamp(0.65rem, 2vw, 0.75rem)",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Ward Rounds
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {isModalOpen && (
        <DetailedNurseNotes
          closeModal={closeModal}
          treatment={viewing}
          patientName={patientName}
          patientId={viewing?.patient?.id}
        />
      )}

      {wardRoundModalOpen && (
        <WardRoundNotes
          closeModal={closeModal}
          treatment={viewing}
          patientName={patientName}
          patientId={viewing?.patient?.id}
          getAllAdmittedPatients={getAdmittedPatientsFunc}
        />
      )}
    </div>
  );
}
export default AdmitCheck;
